import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

const NAV_ITEMS = [
  { label: "首页", to: "/" },
  { label: "电影", to: "/category/movies" },
  { label: "电视剧", to: "/category/tv" },
  { label: "搜索", to: "/search" },
  { label: "关于我们", to: "/about" },
];

export default function SiteNavbar() {
  const location = useLocation();
  const isHome = location.pathname === "/";
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname, location.search]);

  const solid = !isHome || scrolled || menuOpen;

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        solid
          ? "border-b border-background-200 bg-background-50/95 backdrop-blur"
          : "border-b border-transparent bg-transparent"
      }`}
    >
      <div className="page-shell flex h-16 items-center justify-between gap-4 md:h-20">
        <Link to="/" className="flex items-center gap-2.5 whitespace-nowrap">
          <span
            className={`flex h-9 w-9 items-center justify-center rounded-md text-lg ${
              solid ? "bg-primary-500 text-background-50" : "bg-background-50/95 text-primary-600"
            }`}
          >
            <i className="ri-film-line" aria-hidden="true"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span
              className={`font-heading text-lg font-extrabold tracking-tight md:text-xl ${
                solid ? "text-foreground-950" : "text-background-50"
              }`}
            >
              新金瓶梅
            </span>
            <span
              className={`mt-0.5 hidden text-[11px] tracking-[0.2em] sm:block ${
                solid ? "text-foreground-500" : "text-background-200"
              }`}
            >
              影视资讯 · 剧情介绍
            </span>
          </span>
        </Link>

        <nav className="hidden items-center gap-1 md:flex">
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              className={({ isActive }) =>
                `whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium transition-colors ${
                  solid
                    ? isActive
                      ? "bg-primary-100 text-primary-700"
                      : "text-foreground-700 hover:bg-background-200 hover:text-foreground-950"
                    : isActive
                      ? "bg-background-50/20 text-background-50"
                      : "text-background-100 hover:bg-background-50/15 hover:text-background-50"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <Link
            to="/search"
            aria-label="搜索影视"
            className={`hidden h-10 w-10 items-center justify-center rounded-md text-lg transition-colors md:flex ${
              solid
                ? "bg-background-100 text-foreground-800 hover:bg-background-200"
                : "bg-background-50/15 text-background-50 hover:bg-background-50/25"
            }`}
          >
            <i className="ri-search-line" aria-hidden="true"></i>
          </Link>
          <button
            type="button"
            onClick={() => setMenuOpen((prev) => !prev)}
            aria-label="打开导航菜单"
            aria-expanded={menuOpen}
            className={`flex h-10 w-10 items-center justify-center rounded-md text-xl transition-colors md:hidden ${
              solid
                ? "bg-background-100 text-foreground-900"
                : "bg-background-50/15 text-background-50"
            }`}
          >
            <i className={menuOpen ? "ri-close-line" : "ri-menu-line"} aria-hidden="true"></i>
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 md:hidden">
          <nav className="page-shell flex flex-col py-2">
            {NAV_ITEMS.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) =>
                  `flex items-center justify-between rounded-md px-3 py-3 text-sm font-medium transition-colors ${
                    isActive
                      ? "bg-primary-100 text-primary-700"
                      : "text-foreground-800 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
                <i className="ri-arrow-right-s-line text-lg text-foreground-400" aria-hidden="true"></i>
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}